import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./sidebar";
import Header from "./header";
import routerService from '../../routes/index';
import { useUser } from "../../core/context/user";
import { useEffect } from "react";
import ProtectedRoute from '../../components/protectedRoutes';
import ErrorBoundary from '../../components/error-boundary';

const DefaultLayout = () => {
  const { isCurrentUserAdmin, userData } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!userData) {
      navigate("/signIn");
    }
  }, [userData, navigate]);

  const currentRole = () => {
    return isCurrentUserAdmin() ? 'admin' : 'customer';
  };

  return (
    <div className="main-wrapper">
      <Header />
      {/* Boundary per pagina: een render-fout op één pagina haalt niet de hele
          app (incl. sidebar) onderuit, en elke navigatie reset de boundary. */}
      <ErrorBoundary variant="inline" resetKey={location.key}>
      <Routes>
        {routerService
          .filter(val => val.path.includes(currentRole()))
          .map((route, key) => (
            <Route
              key={key}
              path={`/${route.path}`}
              element={
                <ProtectedRoute>
                  <route.component />
                </ProtectedRoute>
              }
            />
          ))}
        <Route path="*" element={<Navigate to="/error-404" replace />} />
      </Routes>
      </ErrorBoundary>
      <Sidebar />
      <div className="sidebar-overlay"></div>
    </div>
  );
};

export default DefaultLayout;
